import { gsap } from "gsap";

export default class Faq {
  constructor(el) {
    this.el = el;

    this.init();
  }

  init() {
    this.items = [...this.el.querySelectorAll(".c-faq__item")];

    this.items.forEach((item) => {
      const answer = item.querySelector(".c-faq__answer");
      gsap.set(answer, { height: 0, overflow: "hidden" });

      item.querySelector(".c-faq__header").addEventListener("click", () => {
        this.toggle(item);
      });
    });
  }

  toggle(item) {
    const isActive = item.classList.contains("is-active");

    // Close all
    this.items.forEach((i) => {
      if (i.classList.contains("is-active")) {
        i.classList.remove("is-active");
        gsap.to(i.querySelector(".c-faq__answer"), {
          height: 0,
          duration: 0.4,
          ease: "power3.inOut",
        });
      }
    });

    // Open clicked if it was closed
    if (!isActive) {
      item.classList.add("is-active");
      gsap.to(item.querySelector(".c-faq__answer"), {
        height: "auto",
        duration: 0.4,
        ease: "power3.inOut",
      });
    }
  }
}
